module.exports = "/packs/check_24px_outlined-282e1b7b148ff01dc10e56c9259d93f9.svg";